import { createContext, useContext } from 'react';

const EMPTY_SYMBOL = Symbol("EMPTY");
function createScopedContext({
  rootComponentName,
  displayName,
  providerFactory
}) {
  const Context = createContext(
    EMPTY_SYMBOL
  );
  if (
    // eslint-disable-next-line @flexteam/flex-global-config/no-direct-access-flex-global-config
    typeof __FLEX_GLOBAL_CONFIG__ !== "undefined" && __FLEX_GLOBAL_CONFIG__.NODE_ENV === "development"
  ) {
    Context.displayName = displayName;
  }
  return {
    Provider: providerFactory ? providerFactory(Context.Provider) : Context.Provider,
    Consumer: Context.Consumer,
    displayName,
    useContextValue: () => {
      const context = useContext(Context);
      if (context === EMPTY_SYMBOL) {
        throw new Error(
          rootComponentName ? `${displayName}.useContextValue\uB294 ${rootComponentName} \uD558\uC704\uC5D0\uC11C \uC0AC\uC6A9\uD574\uC57C \uD569\uB2C8\uB2E4.` : `${displayName}.useContextValue\uB294 ${displayName}.Provider \uD558\uC704\uC5D0\uC11C \uC0AC\uC6A9\uD574\uC57C \uD569\uB2C8\uB2E4.`
        );
      }
      return context;
    }
  };
}

export { createScopedContext as default };
//# sourceMappingURL=createScopedContext.mjs.map
